import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import stylesQrCom from './qrcom.module.css';
import { WatchIconSVG } from '../../utils/svgdata';
import PaymentIcons from './PaymentIcons';
import ImageComponent from '../ImageComponent';
import SharePng from '../../assets/verticalpayments/share.png';
//import { QRCodeCanvas } from "qrcode.react";
import { formatTimeExpireIn } from '../../utils/DateTimings';
import { QRCode } from "react-qrcode-logo";

import qrLogo from '../../assets/verticalpayments/qr-code-logo.png';
import { useSubscriptionPaymentStore } from '../../storage/subscriptionPaymentStore';
import { CT_PARAMS } from '../../analytics/trackerEvents/cleverTap/parameters';
import { trackCleverTapEvent } from '../../utils/cleverTapHelper';
import { CLEVERTAP_EVENTS } from '../../analytics/trackerEvents/cleverTap/events';
import { useTokenStore } from '../../storage/tokenState';

//const qrLogo = 'https://assets.zupee.com/verticalstudio/dec/26/qrcode.png';

export default function ScannerFile({ topSpaceClass, bottomSpaceClass, expiryShow, expireinTitle, expireinValue, scannerText, scannerbox, paymentIconsShow, paymentConsentText, shareFeatureShow, upiLogos, updateSeesionExpireTime }: { topSpaceClass: string, bottomSpaceClass: string, expiryShow: boolean, expireinTitle: string, expireinValue: string, scannerText: string, scannerbox: boolean, paymentIconsShow: boolean, paymentConsentText: string, shareFeatureShow: boolean, upiLogos: any[], updateSeesionExpireTime: (diff: number) => void }) {

    const [error, setError] = useState<string | null>(null);

    const { token } = useTokenStore();

    const [expireAt, setExpireAt] = useState<number>(Number(expireinValue));
    const [remainingMs, setRemainingMs] = useState<number>(0);
    const subscriptionPaymentDataCtx = useSubscriptionPaymentStore((state) => state.subscriptionPaymentDataCtx);

    const qrCodeRef = useRef<HTMLDivElement | null>(null);
    const shareQrRef = useRef<HTMLDivElement | null>(null);


    useEffect(() => {
        setExpireAt(Number(expireinValue));
      }, [expireinValue]);
      
      useEffect(() => {
        if (!expireAt) return;
      
        const update = () => {
          const diff = expireAt - Date.now();
          setRemainingMs(diff > 0 ? diff : 0);

          updateSeesionExpireTime(diff);

          //if QR code is expired, navigate to subscription payment screen
          // if(diff <= 0) {
          //    setSubscriptionPaymentDataCtx((prev: any) => ({ ...initialSubscriptionPaymentState }));
          //    navigate(NAVIGATION_ROUTES.REFERRAL_SUBSCRIPTION_PAYMENT);
          // }

        };
      
        update(); // initial run
      
        const interval = setInterval(update, 1000);
      
        return () => clearInterval(interval);
      }, [expireAt]);


    const shareQR = async () => {
        setError(null);

        if (!navigator.share) {
          alert("Web Share not supported");
          return;
        }

        // Use a clean QR (without logo/styling) for sharing to improve scan reliability
        const canvas = shareQrRef.current?.querySelector('canvas') as HTMLCanvasElement | null;
        if (!canvas) {
          setError('Unable to find QR to share');
          return;
        }

        canvas.toBlob(async (blob) => {
          if (!blob) {
            setError('Unable to generate QR image');
            return;
          }

          try {
            const file = new File([blob], 'qr-code.png', { type: blob.type || 'image/png' });
            await navigator.share({
              title: subscriptionPaymentDataCtx?.sharedDataCtx?.title,
              text: subscriptionPaymentDataCtx?.sharedDataCtx?.message,
              files: [file],
            });
            const userId = token?.zupeeUserId?.toString() || '';
            trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_SHARE_QR_CODE, {
              [CT_PARAMS.USER_ID]: userId
            });
            
          } catch (error) {
            //if (error?.name === "AbortError") return;
            console.error("Share failed:", error);
            setError("Unable to share QR or share cancelled");
          }
        });
    };
  return (
        <>
        <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecColumn, stylesQrCom.br20, stylesQrCom.p1213, stylesQrCom.wperc100, stylesQrCom.gap11, stylesQrCom.border2, stylesQrCom.boxShadow6, stylesQrCom.bgamount, stylesQrCom[topSpaceClass], stylesQrCom[bottomSpaceClass])}>
            <div className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.flexStyle, stylesQrCom.flexDirecColumn)}>
               

                {expiryShow && <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.justifyContentCenter, stylesQrCom.wperc100, stylesQrCom.gap4, stylesQrCom.alignItemsCenter, stylesQrCom.border4F5568, stylesQrCom.background353945, stylesQrCom.br4, stylesQrCom.p48, stylesQrCom.fontSize12, stylesQrCom.fontWeight500, stylesQrCom[bottomSpaceClass])}>
                      <span className={clsx(stylesQrCom.fontColorWhite)}>{expireinTitle}</span>
                      <span className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.alignItemsCenter, stylesQrCom.displayFlex)}>
                            <WatchIconSVG width={16} height={16} />
                        </span>
                        <span className={clsx(stylesQrCom.fontColorWhite)}>{formatTimeExpireIn(remainingMs)}</span>
                    </div>}


                    {scannerbox && <div ref={qrCodeRef} className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecColumn, stylesQrCom.justifyContentCenter, stylesQrCom.background353945, stylesQrCom.scannerbox, stylesQrCom.br20, stylesQrCom.p20202012)}>

                  {/* <QRCodeCanvas 
                    value={subscriptionPaymentDataCtx?.orderMandateFlowDataCtx} 
                    size={200}  
                    level="H" 
                    imageSettings={{
                        src: qrLogo,
                        width: 30,
                        height: 30,
                        excavate: true,
                    }}
                    /> 
                     <QRCodeCanvas
                      value={subscriptionPaymentDataCtx?.orderMandateFlowDataCtx}
                      size={270}              // 🔥 CRITICAL
                      level="Q"               // Balanced
                      imageSettings={{
                        src: qrLogo,
                        width: 40,            // ~12% of QR
                        height: 40,
                        excavate: true,
                      }}
                    />*/}
                     {/* Visible QR with logo for user */}
                     {/* <QRCode
                      value={subscriptionPaymentDataCtx?.orderMandateFlowDataCtx}
                      size={230}                 // 🔥 Minimum safe size
                      fgColor="#000000"
                      bgColor="#ffffff"
                      quietZone={16}             // 🔥 Mandatory
                      ecLevel="Q"                // Best balance for logo
                      logoImage={qrLogo}
                      logoWidth={30}             // <= 15% of size
                      logoHeight={30}
                      removeQrCodeBehindLogo     // excavates QR behind logo
                      logoPadding={3}            // white padding around logo
                      logoPaddingStyle="square"  // or "circle"
                    /> */}

                      <QRCode size={230}
                      value={subscriptionPaymentDataCtx?.orderMandateFlowDataCtx}
                      fgColor="#000000"
                      bgColor="#ffffff"
                      ecLevel="L"
                      quietZone={12}  
                      qrStyle='squares'
                      eyeRadius={0}
                      />

                    {/* Hidden plain QR (no logo) used only for sharing to ensure best scan quality */}
                    <div
                      ref={shareQrRef}
                      style={{ position: 'absolute', left: -9999, top: -9999 }}
                    >
                      <QRCode size={230}
                      value={subscriptionPaymentDataCtx?.orderMandateFlowDataCtx}
                      fgColor="#000000"
                      bgColor="#ffffff"
                      ecLevel="L"
                      quietZone={12}  
                      qrStyle='squares'
                      eyeRadius={0}
                      />
                    </div>

                    <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.justifyContentCenter, stylesQrCom.wperc100, stylesQrCom.martop10)}>
                        <span className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.fontWeight600, stylesQrCom.lineHeight24, stylesQrCom.fontSize20)}>{scannerText}</span>
                    </div>

                    </div>}

                    {paymentIconsShow && <PaymentIcons 
                    paymentConsentText={paymentConsentText}
                    bottomSpaceClass={bottomSpaceClass}
                    topSpaceClass={topSpaceClass}
                    upiLogos={upiLogos}
                    />}

                    {/* {error && <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.justifyContentCenter, stylesQrCom.gap10)}>
                        <span className={clsx(stylesQrCom.fontColorRed, stylesQrCom.fontWeight600, stylesQrCom.lineHeight24, stylesQrCom.fontSize12)}>{error}</span>
                        </div>} */}

                    {shareFeatureShow &&  <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.justifyContentCenter, stylesQrCom.background353945, stylesQrCom.scannerbox, stylesQrCom.br12, stylesQrCom.p20, stylesQrCom.gap10)} onClick={shareQR}>
                        <ImageComponent src={SharePng} alt="Share QR" style={{ width: '20px', height: '20px' }} />
                        <span className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.fontWeight600, stylesQrCom.lineHeight24, stylesQrCom.fontSize14)}>{subscriptionPaymentDataCtx?.sharedDataCtx?.ctaText}</span>
                        </div>}


                </div>
            </div>
        </>
    );
}
